import React from "react";
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Divider,
  Box,
  Link,
} from "@mui/material";
import { API_BASE_URL } from "../../utils/api";

// Icons
import EmailIcon from "@mui/icons-material/Email";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WcIcon from "@mui/icons-material/Wc";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import SmartphoneIcon from "@mui/icons-material/Smartphone"; // ✅ New for Cell Phone

const MemberDetailsCard = ({ member }) => {
  const joinDate = member.JoinDate ? new Date(member.JoinDate).toLocaleDateString() : "N/A";
  const email = member.EmailAddress?.trim() || "N/A";
  const address = member.FullAddress?.trim() || "N/A";
  const mapsLink = address !== "N/A"
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    : null;

  const phone = member.PhoneNumber?.trim() || null;
  const altPhone = member.AlternatePhoneNumber?.trim() || null;
  const cellPhone = member.CellPhoneNumber?.trim() || null; // ✅ added

  return (
    <Card sx={{ maxWidth: 420, mx: "auto", borderRadius: 3, boxShadow: 4 }}>
      <CardContent sx={{ textAlign: "center" }}>
        <Avatar
          src={`${API_BASE_URL}/images/${encodeURIComponent(member.PhotoGraphicFileName?.trim() || "")}`}
          alt={member.FirstName}
          sx={{
            width: 120,
            height: 120,
            margin: "0 auto",
            marginBottom: 2,
            border: "4px solid #007bff",
          }}
        />
        <Typography variant="h5" fontWeight="bold">
          {`${member.FirstName} ${member.LastName}`}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Member Number: {member.ClubMemberCode}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ textAlign: "left", pl: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <CalendarTodayIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">Join Date: {joinDate}</Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <EmailIcon sx={{ color: "text.secondary", mr: 1 }} />
            {email !== "N/A" ? (
              <Link href={`mailto:${email}`} variant="body2" underline="hover">
                Email: {email}
              </Link>
            ) : (
              <Typography variant="body2">Email: N/A</Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <LocationOnIcon sx={{ color: "text.secondary", mr: 1 }} />
            {mapsLink ? (
              <Link
                href={mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
                underline="hover"
              >
                Address: {address}
              </Link>
            ) : (
              <Typography variant="body2">Address: N/A</Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PhoneIcon sx={{ color: "text.secondary", mr: 1 }} />
            {phone ? (
              <Link href={`tel:${phone}`} variant="body2" underline="hover">
                Phone: {phone}
              </Link>
            ) : (
              <Typography variant="body2">Phone: N/A</Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PhoneAndroidIcon sx={{ color: "text.secondary", mr: 1 }} />
            {altPhone ? (
              <Link href={`tel:${altPhone}`} variant="body2" underline="hover">
                Alt Phone: {altPhone}
              </Link>
            ) : (
              <Typography variant="body2">Alt Phone: N/A</Typography>
            )}
          </Box>

          {/* ✅ Cell Phone Row */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SmartphoneIcon sx={{ color: "text.secondary", mr: 1 }} />
            {cellPhone ? (
              <Link href={`tel:${cellPhone}`} variant="body2" underline="hover">
                Cell: {cellPhone}
              </Link>
            ) : (
              <Typography variant="body2">Cell: N/A</Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MemberDetailsCard;
